/** @format */

import React, { useState, useEffect } from "react";
import Link from "next/link";
import useSettings from "stores/settings";
import IconButton from "@material-ui/core/IconButton";
import { useRouter } from "next/router";
import { DateDescendingOrder } from "components/Function";
// import AppLikeCounㄴt from "components/AppLikeCount";
import UserPhoto from "components/UserPhoto";
import UserName from "components/UserName";
import { projectFirestore } from "components/ProjectFirestore";
import Paginations from "components/Paginations";
import ShareIcon from "@material-ui/icons/Share";
// Marerial Icon
import ReportOutlinedIcon from "@material-ui/icons/ReportOutlined";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import { projectStorage } from "components/ProjectStorage";
import MessageSendModal from "components/modal/MessageSendModal";
import ShareModal from "components/modal/ShareModal";
import { FormatDate } from "components/FormatDate";

import Tooltip from "@material-ui/core/Tooltip";
import LoginModal from "components/modal/LoginModal";
import ReportModal from "components/modal/ReportModal";

import AppCard from "components/appCard/Card";
import UserEmail from "components/UserEmail";

const Profile = () => {
  const router = useRouter();

  /* 페이지네이션 */
  const [pageOfItems, setPageOfItems] = useState([]);
  // const [page, setPage] = useState(settings.aisoMarketPage);

  const [contentsData, setContentsData] = useState(null);
  const [imageItemsCount, setImageItemsCount] = useState(0);
  const [dataItemsCount, setDataItemsCount] = useState(0);

  const [tab, setTab] = useState("market");

  const { id } = router.query;
  let email = UserEmail(id);

  /* 카테고리별 데이터 저장 */
  useEffect(async () => {
    if (email) {
      try {
        const datas = [];
        const collectionRef = projectFirestore.collection("market").doc("public").collection("app");
        const collectionValue = await collectionRef.where("email", "==", email).get();
        collectionValue.forEach((doc) => {
          /* 완성되지 않은 앱은 목록에서 제거 */
          if (doc.data().status === "앱 배포완료" && doc.data().visible) {
            datas.push({ ...doc.data() });
          }
        });
        let tempDatas = datas.sort(DateDescendingOrder);
        if (tab === "dataAnalysis") {
          tempDatas = tempDatas.filter((f) => f.category === "dataAnalysis");
        } else {
          tempDatas = tempDatas.filter((f) => f.category !== "dataAnalysis");
        }
        setContentsData(tempDatas);
        /* 이미지 앱 ,데이터 분석 앱 카운트 */
        const tempImageItemLength = datas.filter((f) => f.category !== "dataAnalysis").length;
        const tempDataItemLength = datas.filter((f) => f.category === "dataAnalysis").length;
        setImageItemsCount(tempImageItemLength);
        setDataItemsCount(tempDataItemLength);
      } catch (error) {
        console.error(error);
      }
    }
  }, [router, tab, email]);

  /* 페이지네이션 */
  const onChangePage = (pageOfItems) => {
    setPageOfItems(pageOfItems);
  };

  return (
    <div className="w-full">
      <div className="page-content w-full pt-10 pb-20">
        {/* 제작자 정보 */}
        <ProfileDotMenu email={email} imageItemsCount={imageItemsCount} dataItemsCount={dataItemsCount} />
        {/* 제작 상품들 리스트 */}
        {contentsData ? (
          <div className="mt-3">
            <div className="row">
              <div className="col-12 mt-2">
                <ul className="flex items-center m-0">
                  <li className="nav-item mr-3">
                    <a className={`nav-link category-simple-menu ${tab === "market" ? "active" : ""}`} onClick={() => setTab("market")}>
                      마켓 앱
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className={`nav-link category-simple-menu ${tab === "dataAnalysis" ? "active" : ""}`}
                      onClick={() => setTab("dataAnalysis")}
                    >
                      데이터 분석 앱
                    </a>
                  </li> */}
                </ul>
              </div>
              {contentsData.length > 0 ? (
                tab === "market" ? (
                  <>
                    <div className="app-content-wrap">
                      {pageOfItems.map((m) => (
                        <UserAppCard data={m} key={m.appId} />
                      ))}
                    </div>
                    <Paginations items={contentsData} onChangePage={onChangePage} />
                  </>
                ) : (
                  <>
                    <div className="col-12 py-3 sm:py-0">
                      {pageOfItems.map((m) => (
                        <DataAnalysisMarketCard {...m} key={m.appId} />
                      ))}
                    </div>
                    <Paginations items={contentsData} onChangePage={onChangePage} />
                  </>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="center w-full py-32">
            <div>Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
};

/* 제작자 정보 */
const ProfileDotMenu = ({ email, imageItemsCount, dataItemsCount }) => {
  const settings = useSettings();

  const photoUrl = UserPhoto(email);
  const appUserName = UserName(email);

  console.log("dataItemsCount : ", dataItemsCount);

  // 모달 값 저장
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [reportModalVisible, setReportModalVisible] = useState(false);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleMessageSendButtonClick = () => {
    /* 로그인 체크하고 로그인 후 이용해달라고 하기 */
    if (!settings.email) {
      setLoginModalVisible(true);
      return "";
    }
    setMessageModalVisible(true);
  };

  const handleReportSendButtonClick = () => {
    /* 로그인 체크하고 로그인 후 이용해달라고 하기 */
    if (!settings.email) {
      setLoginModalVisible(true);
      return "";
    }
    setReportModalVisible(true);
  };

  const handleModalOkButton = async () => {
    const date = new Date();
    const createdAt = FormatDate(date);

    if (title === "") {
      const text = "신고 제목을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    if (content === "") {
      const text = "신고 내용을 입력해주세요.";
      BasicAlert(text);
      return;
    }

    /**
     * 받은 신고 저장 위치 : gcf/{email}/reviewReport/{randomId}
     */

    try {
      const collectionRefUser = await projectFirestore.collection("admin").doc("report").collection("users");
      const values = {
        email,
        name: appUserName,
        reporterEmail: settings.email,
        reporterName: settings.name,
        title,
        content,
        createdAt,
        status: "미확인",
      };
      await collectionRefUser.add(values);
      setTitle("");
      setContent("");
      setReportModalVisible(false);
    } catch (error) {
      console.log(error);
      BasicAlert("신고 등록 실패");
    }
  };

  return (
    <div className="w-full aiso-card shadow-sm py-5">
      <div className="row items-center">
        <div className="col-12 col-sm-3 center">
          <div className="img-cover-box w-24 h-24 rounded-full border">
            <img src={photoUrl} className="rounded-full" alt="user photo" />
          </div>
        </div>
        <div className="col-12 col-sm-9">
          <div className="flex justify-center items-center justify-content-sm-between align-items-sm-center">
            <div className="flex flex-col flex-sm-row items-center justify-between w-full">
              <p className="truncate-1-lines text-2xl text-555 mt-3 mb-0 mr-sm-3 font-bold">{appUserName}</p>
              {/* 아이콘 영역 */}
              <div className="flex justify-between pt-2 sm:pt-0">
                <div className="mr-3">
                  <Tooltip title="메시지 보내기">
                    <IconButton color="primary" onClick={handleMessageSendButtonClick} className="p-2">
                      <ChatBubbleOutline className="text-333" />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="mr-3">
                  <Tooltip title="신고하기">
                    <IconButton color="primary" onClick={handleReportSendButtonClick} className="p-2">
                      <ReportOutlinedIcon className="text-333" />
                    </IconButton>
                  </Tooltip>
                </div>
                <MessageSendModal
                  messageModalVisible={messageModalVisible}
                  closeModal={() => setMessageModalVisible(false)}
                  receiveEmail={email}
                  receiveUserName={appUserName}
                />
                <ReportModal
                  modalVisible={reportModalVisible}
                  closeModal={() => setReportModalVisible(false)}
                  handleModalOkButton={handleModalOkButton}
                  title={title}
                  setTitle={setTitle}
                  content={content}
                  setContent={setContent}
                />
                <LoginModal modalVisible={loginModalVisible} closeModal={() => setLoginModalVisible(false)} />
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col flex-sm-row justify-center justify-content-sm-start items-center">
            <div className="mt-3">
              <p className="text-sm mr-sm-5">
                <span className="text-555 pr-2">마켓 앱</span>
                <span className="text-333 font-black">{imageItemsCount}</span>
              </p>
            </div>
            {/* <div className="mt-3">
              <p className="text-sm mr-sm-5">
                <span className="text-555 pr-2">데이터 분석 앱</span>
                <span className="text-333 font-black">{dataItemsCount}</span>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const UserAppCard = ({ data }) => {
  return <AppCard data={data} pathname={`/user/market/[id]`} query={{ id: data.appId }} />;
};

/* 데이터 분석 카드 */
const DataAnalysisMarketCard = ({ appId, email, appName, price, createdAt, oneLineContent, useCount, imageUrl }) => {
  /* preview 가져오기 */
  /* 사용자 프로필 가져오기 */
  const photoUrl = UserPhoto(email);
  const name = UserName(email);

  /* 좋아요 수 체크 */
  // const likeCount = AppLikeCount(email, appId);
  const [appImage, setAppImage] = useState();

  useEffect(() => {
    if (imageUrl) {
      const storageFileRef = projectStorage.ref(imageUrl);

      storageFileRef.getDownloadURL().then((url) => {
        try {
          setAppImage(url);
        } catch (e) {
          console.log(e);
        }
      });
    }
  }, [imageUrl]);
  /* Modal */
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row items-center aiso-data-card aiso-shadow mb-3">
        <Link
          href={{
            pathname: "/user/dataAnalysis/[id]",
            query: {
              id: `${appId}`,
            },
          }}
        >
          <div className="w-full sm:w-2/12">
            <div className="img-cover-box  h-48">
              <img src={appImage ? appImage : "/images/market/no-img.png"} className="rounded-tl-md rounded-bl-md" />
            </div>
          </div>
        </Link>
        <div className="w-full sm:w-10/12 py-3">
          <div className="w-full flex justify-between items-center px-3">
            <Link
              href={{
                pathname: "/user/dataAnalysis/[id]",
                query: {
                  id: `${appId}`,
                },
              }}
            >
              <div className="px-3">
                <div className="truncate-2-lines text-333 font-bold font-gmarket-medium">{appName}</div>
                <div className="truncate-1-lines font-gmarket-medium text-888 mt-2">
                  <div dangerouslySetInnerHTML={{ __html: oneLineContent }} />
                  {/* <LinesEllipsis
                    text={<div className="text-xs" dangerouslySetInnerHTML={{ __html: content }} />}
                    // maxLine="1"
                    // ellipsis="..."
                    // trimRight
                    basedOn="letters"
                  /> */}
                </div>
                <div className="flex">
                  <p className="text-ss text-333 font-gmarket-medium mr-5">
                    <span className="font-bold text-sm">{useCount ? useCount : "0"}</span> 회 사용
                  </p>
                </div>
              </div>
            </Link>
            {/* 앱 공유 */}
            <div>
              <Tooltip title="공유하기">
                <IconButton color="primary" onClick={handleOpen} className="p-2">
                  <ShareIcon className="text-333" />
                </IconButton>
              </Tooltip>
              <ShareModal
                open={open}
                handleClose={handleClose}
                path={`/user/dataAnalysis/${appId}`}
                title={appName}
                description={oneLineContent}
              />
            </div>
          </div>
          <div className="w-full flex justify-between items-end px-3 mt-3">
            <div className="flex justify-start items-center px-3">
              <div>
                <div className="img-cover-box w-10 h-10 rounded-full border">
                  <img src={photoUrl} alt="profile" />
                </div>
              </div>
              <div className="whitespace-pre-line break-all ml-2">
                <p className="truncate-1-lines mb-0 text-555 font-gmarket-medium text-sm">{name}</p>
                <p className="mb-0 text-aaa font-gmarket-medium text-xs">{createdAt.substring(0, 16)}</p>
              </div>
            </div>
            <div className="px-3">
              <p className="text-xs text-333 font-gmarket-medium">
                <span className="font-bold text-base text-primary">{price}</span> Credit
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
